// extracted by mini-css-extract-plugin
export var body = "_g1-5";
export var closeButton = "_g1-f";
export var container = "_g1-1";
export var content = "_g1-2";
export var cta = "_g1-c";
export var ctaLabel = "_g1-b";
export var eyebrow = "_g1-3";
export var howTo = "_g1-6";
export var image = "_g1-e";
export var modal = "_g1-0";
export var socialButton = "_g1-d";
export var stepCard = "_g1-8";
export var stepLabel = "_g1-a";
export var stepNumber = "_g1-9";
export var steps = "_g1-7";
export var title = "_g1-4";